export default function getRowIndex(
  row: { index: number } | number,
  { pageSize, pageIndex }: { pageSize: number; pageIndex: number }
): number {
  if (typeof row === 'number') {
    return row + pageIndex * pageSize
  } else {
    return row.index + pageIndex * pageSize
  }
}
